import fetchAPI from '../../fetchAPI';

export const callDeleteCoreKnowledgeBase = async ({
  locationId,
  knowledgeBaseId
}: {
  locationId: string;
  knowledgeBaseId?: string;
}): Promise<iResponse<Pagination<{ id: string; queation: string; answer: string }>>> => {
  const response: iResponse<Pagination<{ id: string; queation: string; answer: string }>> =
    await fetchAPI({
      method: `DELETE`,
      route: `knowledge/location/${locationId}`,
      queryString: knowledgeBaseId ? `knowledgeBaseId=${knowledgeBaseId}` : undefined,
      isZazu: true
    });

  return response;
};

export default callDeleteCoreKnowledgeBase;
